// src/utils/storageKeys.ts
// ============================================================================
// LocalStorage Keys - Separate file to avoid circular imports
// ============================================================================

/** LocalStorage key for client ID */
export const STORAGE_KEY_CLIENT_ID = "wim_hof_client_id";

/** LocalStorage key for language preference */
export const STORAGE_KEY_LANGUAGE = "wim_hof_language";

/** LocalStorage key for voice name indices */
export const STORAGE_KEY_VOICE_NAME = "wim_hof_voice_name_indices";

/** LocalStorage key for theme preference */
export const STORAGE_KEY_THEME = "theme";
